import { render, staticRenderFns } from "./HigBtn.vue?vue&type=template&id=59ccabe2"
import script from "./HigBtn.vue?vue&type=script&lang=js"
export * from "./HigBtn.vue?vue&type=script&lang=js"
import style0 from "./HigBtn.vue?vue&type=style&index=0&id=59ccabe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports